<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Is payment taxable?<Caret /></summary>
  <p>
    For the vast majority of individuals, the compensation itself is tax free.
  </p>
  <p>
    If you have any questions about this, we advise you to check your specific tax position.
  </p>
</details>
